/* eslint-disable no-console */
const timestamp = () => new Date().toLocaleString()

export const clientLogger = {
  info: (...args: unknown[]) => console.info(timestamp(), '[client]', ...args),
  warn: (...args: unknown[]) => console.warn(timestamp(), '[client]', ...args),
  error: (...args: unknown[]) => console.error(timestamp(), '[client]', ...args),
  debug: (...args: unknown[]) => console.debug(timestamp(), '[client]', ...args),
}
